import { PrivacySettingToggle } from '@prisjakt/web-app-config/types/market';

const acceptCookies = (
  version: string,
  privacySettings?: PrivacySettingToggle,
  isLoggedIn?: boolean
) =>
  ({
    type: 'ACCEPT_COOKIES',
    version,
    privacySettings,
    isLoggedIn,
  } as const);

export default acceptCookies;
